import {BrowserModule, Title} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SecurityModule} from './security/security.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


import {PanelModule} from 'primeng/panel';
import {MessageService} from 'primeng/api';
import {NewAdTypesComponent} from './components/views/settings/new-ad-types/new-ad-types.component';

import {NavigationService} from './service/navigation.service';
import {UserService} from './service/user.service';
import { authInterceptorProviders } from './inteceptors/auth.inteceptor';
import {CookieService} from './service/cookie.service';
import { MainNavigationComponent } from './components/navigation/main-navigation/main-navigation.component';
import { FooterComponent } from './components/footer/footer.component';
import { DynamicFormItemComponent } from './components/forms/dynamic-form-item/dynamic-form-item.component';
import { DynamicFormComponent } from './components/forms/dynamic-form/dynamic-form.component';
import {FormControlService} from './service/form-control.service';
import {DynamicFormItemsService} from './service/dynamic-form-items.service';
import {ToolbarModule} from 'primeng/toolbar';
import {MenubarModule} from 'primeng/menubar';
import {MenuModule} from 'primeng/menu';
import {Drawer} from 'primeng/drawer';
import {CardModule} from 'primeng/card';
import {PanelMenuModule} from 'primeng/panelmenu';
import {ToggleSwitch} from 'primeng/toggleswitch';
import {SliderModule} from 'primeng/slider';
import {AccordionModule} from 'primeng/accordion';
import {TabsModule} from 'primeng/tabs';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {Select} from 'primeng/select';
import {CheckboxModule} from 'primeng/checkbox';
import { TrackUnsavedChangesDirective } from './directives/track-unsaved-changes.directive';
import {ToastModule} from 'primeng/toast';
import {AdTypesSettingsService} from './service/ad-types-settings.service';
import {BusinessCategoryConfigurationsService} from './service/business-category-configurations.service';
import {SentenceCase} from './pipes/sentence-case-pipe';
import { ManageFiltersComponent } from './components/views/ad-filters/manage-filters/manage-filters.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {InputText} from 'primeng/inputtext';
import {MultiSelectModule} from 'primeng/multiselect';
import { MappingRulesComponent } from './components/views/inventory/mapping-rules/mapping-rules.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {TooltipModule} from 'primeng/tooltip';
import { PagesListComponent } from './components/views/pages/pages-list/pages-list.component';
import {Slider} from 'primeng/slider';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {CommonModule} from '@angular/common';
import { GoogleAdsSettingsComponent } from './components/views/settings/google-ads-settings/google-ads-settings.component';
import { HasProperty} from './pipes/has-property-pipe';
import {DatePicker} from 'primeng/datepicker';
import { ManagePasswordComponent } from './components/views/password-settings/manage-password/manage-password.component';
import {PasswordModule} from 'primeng/password';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { SourceShortcodesComponent } from './components/views/settings/source-shortcodes/source-shortcodes.component';
import { AccountShortcodesComponent } from './components/views/settings/account-shortcodes/account-shortcodes.component';
import {PageFilterPipe} from './pipes/page-filter.pipe';
import {ToggleButtonModule} from 'primeng/togglebutton';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {TableModule} from 'primeng/table';
import { BudgetManagementComponent } from './components/views/settings/google-ads-settings/budget-management/budget-management.component';
import {ProgressBarModule} from 'primeng/progressbar';
import { AccountInventoryUrlsComponent } from './components/views/inventory/account-inventory-urls/account-inventory-urls.component';
import {DividerModule} from 'primeng/divider';
import { ForgotPasswordComponent } from './components/views/password-settings/forgot-password/forgot-password.component';
import { EventPageTemplateComponent } from './components/views/templates/event-page-template/event-page-template.component';
import { ResetPasswordComponent } from './components/views/password-settings/reset-password/reset-password.component';
import {PageConfigurationComponent} from './components/views/pages/page-configuration/page-configuration.component';
import { BudgetTemplateComponent } from './components/views/templates/budget-template/budget-template.component';
import { AccountDashboardComponent } from './components/views/dashboard/account-dashboard/account-dashboard.component';
import { PaginatorModule } from 'primeng/paginator';
import { AccountCardComponent } from './components/views/dashboard/account-dashboard/account-card/account-card.component';
import { GoogleAdsAutomationComponent } from './components/views/settings/google-ads-settings/google-ads-automation/google-ads-automation.component';
import { AutomationAccountSettingsComponent } from './components/views/settings/google-ads-settings/google-ads-automation/automation-account-settings/automation-account-settings.component';
import { MpopUsersComponent } from './components/views/mpop-side-nav/users/mpop-users/mpop-users.component';
import { UserFilterPipe } from './pipes/user-filter.pipe';
import {ScrollerModule} from 'primeng/scroller';
import { UserProfileComponent } from './components/views/mpop-side-nav/users/user-profile/user-profile.component';
import {OfferRulesComponent} from './components/views/settings/new-ad-types/offer-rules/offer-rules.component';
import {AutomationConfigurationSettingsComponent} from './components/views/settings/google-ads-settings/google-ads-automation/automation-configuration-settings/automation-configuration-settings.component';
import {Popover} from 'primeng/popover';
import {AccountVlpUrlsComponent} from './components/views/inventory/account-vlp-urls/account-vlp-urls.component';
import {MediaManagementComponent} from './components/views/settings/media-management/media-management.component';
import {GoogleSettingsComponent} from './components/views/settings/media-management/google/google-settings.component';
import {FacebookSettingsComponent} from './components/views/settings/media-management/facebook/facebook-settings.component';
import {MicrosoftSettingsComponent} from './components/views/settings/media-management/microsoft/microsoft-settings.component';
import {MediaTagsSettingsComponent} from './components/views/settings/media-management/media-tags/media-tags-settings.component';
import {GeneralSettingsComponent} from './components/views/settings/media-management/general/general-settings.component';
import {SharedOfferSetRulesComponent} from './components/views/mpop-side-nav/shared-offer-set-rules/shared-offer-set-rules/shared-offer-set-rules.component';
import {TagModule} from 'primeng/tag';
import {BadgeModule} from 'primeng/badge';
import {SharedOfferSetRulesTableComponent} from './components/views/mpop-side-nav/shared-offer-set-rules/shared-offer-set-rules-table/shared-offer-set-rules-table.component';
import {InventoryMappingComponent} from './components/views/inventory/inventory-mapping/inventory-mapping.component';
import {ScrollTopModule} from 'primeng/scrolltop';
import {SharedOfferSetRulesEntryComponent} from './components/views/mpop-side-nav/shared-offer-set-rules/shared-offer-set-rules-entry/shared-offer-set-rules-entry.component';
import {SharedOfferSetRulesFilterComponent} from './components/views/mpop-side-nav/shared-offer-set-rules/shared-offer-set-rules-entry/shared-offer-set-rules-filter/shared-offer-set-rules-filter.component';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SharedOfferSetRulesPreviewComponent} from './components/views/mpop-side-nav/shared-offer-set-rules/shared-offer-set-rules-entry/shared-offer-set-rules-preview/shared-offer-set-rules-preview.component';
import {OfferSetRuleSummaryPipe} from './pipes/offer-set-rule-summary.pipe';
import {ConditionalIncentiveConfiguratorComponent} from './components/views/settings/new-ad-types/conditional-incentive-configurator/conditional-incentive-configurator.component';
import {MediaAdCopyBulkUpdateComponent} from './components/views/mpop-side-nav/media-ad-copy-bulk-update/media-ad-copy-bulk-update.component';
import {BulkUpdateAccountFilterComponent} from './components/views/mpop-side-nav/media-ad-copy-bulk-update/bulk-update-account-filter/bulk-update-account-filter.component';
import {BulkUpdateFilterPreviewComponent} from './components/views/mpop-side-nav/media-ad-copy-bulk-update/bulk-update-account-filter/bulk-update-filter-preview/bulk-update-filter-preview.component';
import {PreviewCampaignBulkUpdateComponent} from './components/views/mpop-side-nav/media-ad-copy-bulk-update/preview-campaigns-bulk-update/preview-campaign-bulk-update.component';
import { AdvancedSettingsComponent } from './components/views/settings/advanced/advanced-settings.component';
import { AdvancedSettingsFeatureModule } from './components/views/settings/advanced/advanced-settings.module';
import { BulkUpdateExecutionComponent } from './components/views/mpop-side-nav/media-ad-copy-bulk-update/bulk-update-execution/bulk-update-execution.component';
import {BulkUpdateExecutionDetailComponent} from './components/views/mpop-side-nav/media-ad-copy-bulk-update/bulk-update-execution/bulk-update-execution-detail/bulk-update-execution-detail.component';
import {IpopConfigurationComponent} from './components/views/settings/ipop/ipop-configuration.component';
import {PrivateOffersComponent} from './components/views/settings/ipop/private-offers/private-offers.component';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import {Textarea} from 'primeng/textarea';
import {IconFieldModule} from 'primeng/iconfield';
import {InputIconModule} from 'primeng/inputicon';
import {StepperModule} from 'primeng/stepper';
import {CruiseControlComponent} from './components/views/settings/cruise-control/cruise-control.component';
import {CruiseControlFormComponent} from './components/views/settings/cruise-control/cruise-control-form/cruise-control-form.component';
import {CruiseControlService} from './service/cruise-control.service';
import {VdpOffersComponent} from './components/views/settings/ipop/vdp-offers/vdp-offers.component';
import {FieldsetModule} from 'primeng/fieldset';
import {MessageModule} from 'primeng/message';
import {SelectButtonModule} from 'primeng/selectbutton';
import {
  OfferSetRulesComponent
} from './components/views/settings/ipop/offer-set-rules/offer-set-rules.component';
import {InputNumber} from 'primeng/inputnumber';
import {
  OfferSetRuleModalComponent
} from './components/views/settings/ipop/offer-set-rules/offer-set-rule-modal.component';

@NgModule({ declarations: [
        AppComponent,
        MainNavigationComponent,
        FooterComponent,
        DynamicFormItemComponent,
        DynamicFormComponent,
        TrackUnsavedChangesDirective,
        SentenceCase,
        ManageFiltersComponent,
        MappingRulesComponent,
        PagesListComponent,
        PageFilterPipe,
        GoogleAdsSettingsComponent,
        HasProperty,
        ManagePasswordComponent,
        SourceShortcodesComponent,
        AccountShortcodesComponent,
        BudgetManagementComponent,
        AccountInventoryUrlsComponent,
        AccountVlpUrlsComponent,
        ForgotPasswordComponent,
        EventPageTemplateComponent,
        ResetPasswordComponent,
        PageConfigurationComponent,
        BudgetTemplateComponent,
        AccountDashboardComponent,
        AccountCardComponent,
        GoogleAdsAutomationComponent,
        NewAdTypesComponent,
        AutomationAccountSettingsComponent,
        NewAdTypesComponent,
        MpopUsersComponent,
        UserFilterPipe,
        UserProfileComponent,
        OfferRulesComponent,
        AutomationConfigurationSettingsComponent,
        MediaManagementComponent,
        GoogleSettingsComponent,
        FacebookSettingsComponent,
        MicrosoftSettingsComponent,
        MediaTagsSettingsComponent,
        GeneralSettingsComponent,
        SharedOfferSetRulesComponent,
        SharedOfferSetRulesTableComponent,
        InventoryMappingComponent,
        SharedOfferSetRulesEntryComponent,
        SharedOfferSetRulesFilterComponent,
        OfferSetRuleSummaryPipe,
        SharedOfferSetRulesPreviewComponent,
        MediaAdCopyBulkUpdateComponent,
        ConditionalIncentiveConfiguratorComponent,
        BulkUpdateAccountFilterComponent,
        BulkUpdateFilterPreviewComponent,
        PreviewCampaignBulkUpdateComponent,
        BulkUpdateFilterPreviewComponent,
        AdvancedSettingsComponent,
        BulkUpdateExecutionComponent,
        BulkUpdateExecutionDetailComponent,
        IpopConfigurationComponent,
        PrivateOffersComponent,
        FooterComponent,
        CruiseControlComponent,
        CruiseControlFormComponent,
        PrivateOffersComponent,
        VdpOffersComponent,
        OfferSetRulesComponent,
        OfferSetRuleModalComponent
    ],
    exports: [
        TrackUnsavedChangesDirective,
        MainNavigationComponent,
        FooterComponent
    ],
    bootstrap: [AppComponent],
  imports: [BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    SecurityModule,
    PanelModule,
    ToolbarModule,
    MenubarModule,
    MenuModule,
    Drawer,
    CardModule,
    PanelMenuModule,
    SliderModule,
    AccordionModule,
    ToggleSwitch,
    TabsModule,
    InputTextModule,
    ReactiveFormsModule,
    Select,
    ButtonModule,
    ToastModule,
    CheckboxModule,
    AutoCompleteModule,
    InputText,
    MultiSelectModule,
    DragDropModule,
    TooltipModule,
    Slider,
    DialogModule,
    ConfirmDialogModule,
    CommonModule,
    CardModule,
    DatePicker,
    PasswordModule,
    ProgressSpinnerModule,
    ToggleButtonModule,
    NgIdleKeepaliveModule.forRoot(),
    TableModule,
    ProgressBarModule,
    DividerModule,
    PaginatorModule,
    ScrollerModule,
    Popover,
    TagModule,
    BadgeModule,
    ScrollTopModule,
    RadioButtonModule,
    AdvancedSettingsFeatureModule,
    Textarea,
    IconFieldModule,
    InputIconModule,
    StepperModule,
    FieldsetModule,
    MessageModule,
    SelectButtonModule, InputNumber
  ],
    providers: [
        Title,
        MessageService,
        NavigationService,
        UserService,
        CookieService,
        FormControlService,
        DynamicFormItemsService,
        authInterceptorProviders,
        AdTypesSettingsService,
        BusinessCategoryConfigurationsService,
        ConfirmationService,
        CruiseControlService,
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
          theme: {
            preset: Aura,
            options: {
              darkModeSelector: false
            }
          }
        })
    ] })
export class AppModule {
}
